<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-h5`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 5a1 1 0 011 1v16h17V6a1 1 0 011-1h2a1 1 0 011 1v36a1 1 0 01-1 1h-2a1 1 0 01-1-1V26H6v16a1 1 0 01-1 1H3a1 1 0 01-1-1V6a1 1 0 011-1h2zm38.922 12a1 1 0 011 1v1.997a1 1 0 01-1 1H35.69l-.93 5.025c1.157-.66 2.363-.993 3.614-.993 2.132 0 3.948.808 5.417 2.413C45.263 29.048 46 31.117 46 33.616c0 2.368-.641 4.43-1.92 6.164-1.566 2.142-3.717 3.22-6.408 3.22-2.2 0-4.02-.676-5.433-2.033-1.415-1.358-2.225-3.162-2.424-5.384a.55.55 0 01.497-.597l2.873-.263a.531.531 0 01.554.364l.02.09c.204 1.444.662 2.502 1.366 3.196.704.693 1.545 1.036 2.547 1.036 1.213 0 2.226-.489 3.07-1.484.847-1.001 1.274-2.338 1.274-4.038 0-1.605-.406-2.84-1.21-3.738-.804-.896-1.853-1.343-3.181-1.343-.822 0-1.555.2-2.207.599-.66.403-1.171.92-1.543 1.555l-.17.291-2.46-.347a1 1 0 01-.86-1.013l.015-.148 2.073-11.914a1 1 0 01.985-.829h10.464z"/></svg>
</template>
<script>

export default {
  name: 'IconH5',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
